module.exports = __webpack_public_path__ + "img/13.3fb7d48d.jpg";